module.exports = __webpack_public_path__ + "static/media/instagram.d3a7ce39.png";